import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className="skeleton-questions-container">
        <Skeleton
          className="skeleton-questions-illustration"
          variant="circle"
        />
        <Skeleton className="skeleton-questions-title" variant="text" />
        <Skeleton className="skeleton-questions-button" variant="rect" />
      </Box>
    </Box>
  );
};

export default Loading;
